import nikhil from "../assets/team/nikhil-gupta.jpg";
import rakesh from "../assets/team/rakesh-gupta.jpg";
import vijay from "../assets/team/vijay-gupta.jpg";
import ruchika from "../assets/team/ruchika-gupta.jpg";
import deepak from "../assets/team/deepak-singh.jpg";

/** Shared team portrait map keyed by TEAM[].id */
export const TEAM_PHOTOS = {
  nikhil,
  rakesh,
  vijay,
  ruchika,
  deepak,
};
